import React from 'react';
import { motion } from 'framer-motion';
import { Quote, Star } from 'lucide-react';
import { useTranslation } from '../i18n/LanguageContext';
export function TestimonialsSection() {
  const {
    t
  } = useTranslation();
  return <section id="testimonials" className="py-24 bg-white relative" data-id="element-524">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-525">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-526">
          <h2 className="font-serif text-4xl text-gray-900 mb-4" data-id="element-527">
            {t.testimonials.heading1}
          </h2>
          <p className="font-script text-3xl text-lavender-600" data-id="element-528">
            {t.testimonials.heading2}
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-529">
          {t.testimonials.items.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-cream-50 rounded-2xl p-8 border border-lavender-50 relative shadow-sm hover:shadow-md transition-shadow" data-id="element-530">
              <Quote className="absolute top-6 right-6 w-8 h-8 text-lavender-200" data-id="element-531" />
              <div className="flex gap-1 mb-6" data-id="element-532">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 text-gold-500 fill-gold-500" data-id="element-533" />)}
              </div>
              <p className="text-gray-700 italic mb-8 leading-relaxed relative z-10" data-id="element-534">
                "{testimonial.text}"
              </p>
              <div className="mt-auto" data-id="element-535">
                <p className="font-serif font-semibold text-gray-900" data-id="element-536">
                  {testimonial.name}
                </p>
                <p className="text-sm text-gray-500" data-id="element-537">{testimonial.location}</p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}